import { useNavigate } from "react-router-dom";
import useSWRMutation from "swr/mutation";
import UserSelector from "@/components/user-selector";
import type { PickerUser } from "@/components/user-selector";
import { useToast } from "@/hooks/use-toast";
import { toastError } from "@/lib/toast";
import { mutateRequest, postFetcher } from "@/lib/swr";
import type { User } from "@/lib/swr";

// Admin-only: disable a bot account. The server transfers every PRD the bot
// owns to the picked user, drops its app bindings and token, then soft-deletes.
export const DisableBotButton = ({ user }: { user: User }) => {
  const { toast } = useToast();
  const navigate = useNavigate();
  const { trigger, isMutating } = useSWRMutation(
    `/bots/${user.id}/disable`,
    postFetcher<{ transferred: number }>
  );

  return (
    <UserSelector
      hideUsers={[user as PickerUser]}
      onContinue={async (to) => {
        if (!to) return;
        try {
          const res = await trigger({ transferToUserId: String(to.id) });
          mutateRequest("/users/full");
          mutateRequest("/users");
          toast({
            title: "Bot disabled",
            description: `${res.transferred} PRDs transferred to ${to.name ?? to.id}`,
          });
          navigate("/admin");
        } catch (err) {
          toastError(toast, "Failed to disable bot", err);
        }
      }}
      buttonText={isMutating ? "Disabling…" : "Disable bot"}
      title="Disable bot"
      description={`Pick who takes over the PRDs owned by ${user.name ?? "this bot"}. The bot's token and app bindings are revoked.`}
    />
  );
};
